import { type DrawerItems } from '@/components/navigation-drawer/Navigation-Drawer-Items';

const settingsDrawerItems: DrawerItems = {
  items: [
    {
      title: 'settings.navigation.platform',
      icon: 'icon-platform',
      actions: [
        'setting.tag.read',
        'setting.alert.read',
        'setting.preferences.write',
        'setting.custom-metadata.read',
        'setting.notification-rule.read',
        'setting.workspace.read',
      ],
      disabled: true,
      items: [
        {
          title: 'app.navigation-drawer.tags',
          actions: ['setting.tag.read'],
          to: {
            name: 'settings.tags',
          },
          dataTrack: 'settings.tags',
        },
        {
          title: 'app.navigation-drawer.custom-metadata',
          actions: ['setting.custom-metadata.read'],
          to: {
            name: 'settings.custom-metadata',
          },
          dataTrack: 'settings.custom-metadata',
        },
        {
          title: 'app.navigation-drawer.ai',
          actions: ['setting.preferences.write'],
          to: {
            name: 'settings.ai',
          },
          dataTrack: 'settings.ai',
        },
        {
          title: 'app.navigation-drawer.tools',
          actions: ['setting.alert.read'],
          to: {
            name: 'settings.tools',
          },
          dataTrack: 'settings.alert',
        },
        {
          title: 'app.navigation-drawer.notifications',
          actions: ['setting.notification-rule.read'],
          to: {
            name: 'settings.notification-rules',
          },
          dataTrack: 'settings.notification-rules',
        },
        {
          title: 'app.navigation-drawer.workspaces',
          actions: ['setting.workspace.read'],
          to: {
            name: 'settings.workspaces',
          },
          dataTrack: 'settings.workspaces',
        },
      ],
    },
    {
      title: 'settings.navigation.monitor',
      icon: 'icon icon-monitor-square',
      actions: ['setting.monitors.automatic-monitoring.write'],
      disabled: true,
      items: [
        {
          title: 'app.navigation-drawer.automatic-monitoring',
          actions: ['setting.monitors.automatic-monitoring.write'],
          to: {
            name: 'settings.monitors.automatic-monitoring',
          },
          dataTrack: 'settings.monitors.automatic-monitoring',
        },
      ],
    },
    {
      title: 'settings.navigation.integration',
      icon: 'icon icon-plug-connection',
      actions: ['setting.preferences.write'],
      disabled: true,
      items: [
        {
          title: 'app.navigation-drawer.integration-preference',
          actions: ['setting.preferences.write'],
          to: {
            name: 'settings.integration',
          },
          dataTrack: 'settings.integration',
        },
        {
          title: 'app.navigation-drawer.credentials',
          actions: ['integration.secrets.read'],
          to: {
            name: 'integrations.credentials',
          },
          dataTrack: 'credentials',
        },
      ],
    },
    {
      title: 'settings.navigation.permissions',
      icon: 'icon-user-admin',
      actions: ['setting.user.read', 'setting.domain.read', 'setting.token.read', 'setting.sso.read'],
      disabled: true,
      items: [
        {
          title: 'app.navigation-drawer.users',
          actions: ['setting.user.read'],
          to: {
            name: 'settings.users',
          },
          dataTrack: 'settings.users',
        },
        {
          title: 'app.navigation-drawer.teams',
          actions: ['setting.user.read'],
          to: {
            name: 'settings.teams',
          },
          dataTrack: 'settings.teams',
        },
        {
          title: 'app.navigation-drawer.domains',
          actions: ['setting.domain.read'],
          to: {
            name: 'domains',
          },
          dataTrack: 'settings.domains',
        },
        {
          title: 'app.navigation-drawer.access',
          actions: ['setting.token.read'],
          to: {
            name: 'settings.access-tokens',
          },
          dataTrack: 'settings.access',
        },
        {
          title: 'app.navigation-drawer.sso',
          actions: ['setting.sso.read'],
          to: {
            name: 'settings.sso',
          },
          dataTrack: 'settings.sso',
        },
      ],
    },
    {
      title: 'settings.navigation.support',
      icon: 'icon-chat-question',
      actions: ['setting.preferences.write'],
      disabled: true,
      items: [
        {
          title: 'app.navigation-drawer.support',
          actions: ['setting.preferences.write'],
          to: {
            name: 'settings.support',
          },
          dataTrack: 'settings.support',
        },
      ],
    },
  ],
};

export default settingsDrawerItems;
